import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';
import { CreateScheduleInput } from '@planbord/shared/models';

export const useAddSchedule = () => {
  const baseUrl = '/api';

  return useMutation({
    mutationFn: (value: CreateScheduleInput) =>
      axiosRequest.post(`${baseUrl}/addSchedule`, value).then((res) => {
        return res.data;
      }),
  });
};
